export default "__VITE_ASSET__DnGHkRNr__"